import bootbox from 'bootbox';

$(document).ready(function (e) {

    $('#integration-crm-table').on('change', function(e){
        let id = $(this).val();

        if(id.length){
            $.ajax({
                type : "GET",
                url : "/settings/integrations/table/fields",
                data : {
                    id
                },
                success : function(res){
                    $('#crm-key-field').empty().append(res.table_fields);
                    $('#related-section').empty().append(res.table_sections);
                    $('#related-section-key').find('option').not(':first').remove();
                    $('.integration-mappings-holder').empty();
                }
            })
        }
    });

    $('#http-method').on('change', function(e){
        let value = $(this).val(),
            name = $('input[name="integration_name"]').val();

        if(value === 'GET'){
            $('.mapping-direction').val('left').attr('disabled', true).trigger('change');
            $('.custom-url-holder').removeClass('d-none');
            $('.trigger-automations-holder').removeClass('d-none');
            $('.trigger-automations-full-sync-holder').toggleClass('d-none', !$('#trigger_automations').is(':checked'));
        }else{
            $('.mapping-direction').val('right').attr('disabled', false).trigger('change');
            $('.custom-url-holder').addClass('d-none');
            $('.trigger-automations-holder').addClass('d-none');
            $('.trigger-automations-full-sync-holder').addClass('d-none');
            $('#trigger_automations, #trigger_automations_full_sync').prop('checked', false);
        }

        if(value === 'PATCH' && name === 'birokrat'){
            $('.call-param-holder').removeClass('d-none');
        }else{
            $('.call-param-holder').addClass('d-none');
        }
    });

    $(document).on('change', '.mapping-direction', function(e){
        e.preventDefault();

        let value = $(this).val(),
            $reverse_type = $(this).parents('.integration-mapping').find('.reverse-type'),
            $reverse_holder = $(this).parents('.integration-mapping').find('.reverse-type-holder'),
            $mapping_holder = $(this).parents('.integration-mapping').find('.mapping-value-holder'),
            $integration_field = $(this).parents('.integration-mapping').find('.integration-field-value'),
            $integration_field_holder = $(this).parents('.integration-mapping').find('.integration-field-holder'),
            $custom_field_holder = $(this).parents('.integration-mapping').find('.custom-value-holder');


        if(value === 'left'){
            $reverse_holder.removeClass('d-none');
            $mapping_holder.removeClass('col-12').addClass('col-9');
            $reverse_type.removeClass('d-none');

            if($integration_field.val() === 'custom'){
                $integration_field.val('').trigger('change');
                $integration_field_holder.removeClass('col-6').addClass('col-12');
                $custom_field_holder.removeClass('d-none').removeClass('col-12').addClass('col-6');
            }

        }else if(value === 'right'){
            $reverse_holder.addClass('d-none');
            $mapping_holder.removeClass('col-9').addClass('col-12');
            $reverse_type.addClass('d-none');
        }
    });

    $('#related-section').on('change', function(e){
        let id = $(this).val(),
            t_id = $(this).find(':selected').attr('data-table-id');

        if(t_id.length){
            $.ajax({
                type : "GET",
                url : "/settings/integrations/table/fields",
                data : {
                    id : t_id
                },
                success : function(res){
                    $('#related-section-key').empty().append(res.table_fields);
                    $('.integration-section-mappings-holder').empty();
                }
            })
        }
    });

    $('.add-integration-mapping').on('click', function(e){
        let id = $('#integration-crm-table').val(),
            method = $('#http-method').val();

        if(id.length){
            $.ajax({
                type : "GET",
                url : "/settings/integrations/table/mapping",
                data : {
                    id,
                    method
                },
                success : function(res){
                    $('.integration-mappings-holder').append(res);
                }
            })
        }else{
            alert('Please select CRM table');
        }
    });

    $('.add-section-mapping').on('click', function(e){
        let selected = $('#related-section').val(),
            id = selected.length ? $('#related-section').find(':selected').attr('data-table-id') : '',
            method = $('#http-method').val();

        if(id.length){
            $.ajax({
                type : "GET",
                url : "/settings/integrations/table/mapping",
                data : {
                    id,
                    method
                },
                success : function(res){
                    $('.integration-section-mappings-holder').append(res);
                }
            })
        }else{
            alert('Please select related section');
        }
    });

    $('.cia-form').one('submit', handleCreateIntegrationActionForm);

    function handleCreateIntegrationActionForm(e){
        e.preventDefault();

        let errors = false,
            $mappings = $('.integration-mappings-holder').find('.integration-mapping'),
            $section_mappings = $('.integration-section-mappings-holder').find('.integration-mapping'),
            mappings = [],
            user_fields = ['assigned_to', 'multi_assigned_to', 'created_by', 'updated_by', 'modified_by'],
            options_fields = ['select', 'multiselect', 'multipleselect', 'radio'],
            section_mappings = [];

        if(!$mappings.length){
            errors = true;
            alert('Please add mappings');
        }

        $mappings.each(function(index, $mapping){
            let field = $($mapping).find('.integration-field-value').val(),
                serp_field = $($mapping).find('.serp-field-value').val(),
                is_related = parseInt($($mapping).find('.integration-field-value').find(':selected').attr('data-is-related')),
                field_name = $($mapping).find('.integration-field-value').find(':selected').attr('data-field-name'),
                direction = $($mapping).find('.mapping-direction').val(),
                type = $($mapping).find('.integration-field-value').find(':selected').attr('data-type'),
                field_type = $($mapping).find('.integration-field-value').find(':selected').attr('data-field_type'),
                related_id = $($mapping).find('.related-field').val(),
                value = $($mapping).find('.custom-value').val(),
                reverse_type = $($mapping).find('.reverse-type').val(),
                payload = {};

            if(!field.length){
                errors = true;
                alert('Please select CRM field');
                return false;
            }

            if(!serp_field.length){
                errors = true;
                alert('Please specify SERP field value');
                return false;
            }

            payload = {
                field : field,
                serp_field : serp_field,
                type : '',
                value  : '',
                select_values : [],
                direction : direction,
                reverse_type : reverse_type
            };

            if(field === 'custom'){
                payload.type = 'custom';
                payload.value = value;
            }

            if(is_related){
                payload.type = 'related';
                payload.value = related_id;
            }

            if(user_fields.includes(field_name)){
                payload.type = 'user_field';
                payload.value = related_id;
            }

            if(options_fields.includes(type)){
                payload.type = 'options_field';

                let $options = $($mapping).find('.options-holder').find('.option');

                $options.each(function($i, $option){
                    let option_key = $($option).find('.option-key').val(),
                        option_value = $($option).find('.option-value').val();

                    console.log(option_key, option_value);

                    payload.select_values.push([option_key, option_value]);
                });
            }

            mappings.push(payload);
        });

        $section_mappings.each(function(index, $mapping){
            let field = $($mapping).find('.integration-field-value').val(),
                serp_field = $($mapping).find('.serp-field-value').val(),
                is_related = parseInt($($mapping).find('.integration-field-value').find(':selected').attr('data-is-related')),
                field_name = $($mapping).find('.integration-field-value').find(':selected').attr('data-field-name'),
                direction = $($mapping).find('.mapping-direction').val(),
                type = $($mapping).find('.integration-field-value').find(':selected').attr('data-type'),
                field_type = $($mapping).find('.integration-field-value').find(':selected').attr('data-field-type'),
                related_id = $($mapping).find('.related-field').val(),
                value = $($mapping).find('.custom-value').val(),
                reverse_type = $($mapping).find('.reverse-type').val(),
                payload = {};

            if(!field.length){
                errors = true;
                alert('Please select CRM field');
                return false;
            }

            if(!serp_field.length){
                errors = true;
                alert('Please specify SERP field value');
                return false;
            }

            payload = {
                field : field,
                serp_field : serp_field,
                type : '',
                value  : '',
                select_values : [],
                direction : direction,
                reverse_type : reverse_type
            };

            if(field === 'custom'){
                payload.type = 'custom';
                payload.value = value;
            }

            if(is_related){
                payload.type = 'related';
                payload.value = related_id;
            }

            if(user_fields.includes(field_name)){
                payload.type = 'user_field';
                payload.value = related_id;
            }

            if(options_fields.includes(type)){
                payload.type = 'options_field';

                let $options = $($mapping).find('.options-holder').find('.option');

                $options.each(function($i, $option){
                    let option_key = $($option).find('.option-key').val(),
                        option_value = $($option).find('.option-value').val();

                    payload.select_values.push([option_key, option_value]);
                });
            }

            section_mappings.push(payload);
        });

        if(!errors){
            $('input[name="action_mappings"]').val(JSON.stringify(mappings));
            $('input[name="section_mappings"]').val(JSON.stringify(section_mappings));
            // console.log(mappings, section_mappings);
            $(this).submit();
        }else{
            $('.cia-form').one('submit', handleCreateIntegrationActionForm);
        }
    }

    $(document).on('change', '.integration-field-value', function(e){
        let value = $(this).val(),
            method = $('#http_method').val(),
            $custom_value = $(this).parents('.integration-mapping').find('.custom-value'),
            $related_fields = $(this).parents('.integration-mapping').find('.related-field'),
            direction = $(this).parents('.integration-mapping').find('.mapping-direction').val(),
            $option_holder = $(this).parents('.integration-mapping').find('.options-holder'),
            is_related = parseInt($(this).find(':selected').attr('data-is-related')),
            field_name = $(this).find(':selected').attr('data-field-name'),
            field_type = $(this).find(':selected').attr('data-field-type'),
            id = $(this).find(':selected').attr('data-id'),
            type = $(this).find(':selected').attr('data-type'),
            user_fields = ['assigned_to', 'multi_assigned_to', 'created_by', 'updated_by', 'modified_by'],
            related_id = parseInt($(this).find(':selected').attr('data-related-id')),
            options_fields = ['select', 'multiselect', 'multipleselect', 'radio'],
            $integration_field_holder = $(this).parents('.integration-mapping').find('.integration-field-holder'),
            $related_field_holder = $(this).parents('.integration-mapping').find('.related-field-holder'),
            $custom_field_holder = $(this).parents('.integration-mapping').find('.custom-value-holder');

        $custom_value.addClass('d-none');
        $related_fields.addClass('d-none');
        $related_field_holder.addClass('d-none');
        $integration_field_holder.addClass('col-12').removeClass('col-6');
        $option_holder.addClass('d-none');

        if(value.length && value === 'custom'){
            if(direction === 'left'){
                $(this).val('');
                alert('Custom value cannot be selected for left mapping direction');
            }else{
                $custom_value.removeClass('d-none');
                $integration_field_holder.removeClass('col-12').addClass('col-6');
                $custom_field_holder.removeClass('d-none').removeClass('col-12').addClass('col-6');
            }

        }else if(is_related && related_id){

            $integration_field_holder.removeClass('col-12').addClass('col-6');
            $related_field_holder.removeClass('d-none').removeClass('col-12').addClass('col-6');
            $.ajax({
                type : "GET",
                url : "/settings/integrations/table/fields",
                data : {
                    id : related_id
                },
                success : (res) => {
                    $related_fields.empty().append(res.table_fields).removeClass('d-none');
                }
            });
        }else if(user_fields.includes(field_name)){
            $integration_field_holder.removeClass('col-12').addClass('col-6');
            $related_field_holder.removeClass('d-none').removeClass('col-12').addClass('col-6');
            $.ajax({
                type : "GET",
                url : '/settings/integrations/table/fields/users',
                data : {
                    id : related_id
                },
                success : (res) => {
                    $related_fields.empty().append(res).removeClass('d-none');
                }
            });
        }else if(options_fields.includes(type)){
            $.ajax({
                type : "GET",
                url : '/settings/integrations/table/fields/options',
                data : {
                    id
                },
                success : (res) => {
                    $option_holder.empty().append(res).removeClass('d-none');
                }
            });
        }
    });

    $('.delete-integration-action').on('click', function(e){
        e.preventDefault();

        let id = $(this).attr('data-action-id');

        if(confirm('Are you sure you want to delete this action')){
            $.ajax({
                type : 'DELETE',
                url : '/settings/integrations/action',
                data : {
                    id
                },
                success : function(res){
                    if(res){
                        window.location.reload();
                    }
                }
            })
        }
    });

    $('.duplicate-integration-action').on('click', function(e){
        e.preventDefault();

        let id = $(this).attr('data-action-id'),
            integration = $(this).attr('data-integration-id');

        $.ajax({
            type : 'POST',
            url : '/settings/integrations/action/duplicate',
            data : {
                id,
                integration
            },
            success : function(res){
                if(res){
                    window.location = res;
                }
            }
        })
    });

    $(document).on('click', '.remove-integration-mapping', function(e){
        $(this).parents('.integration-mapping').remove();
    });

    $('.sync-get-integration').on('click', function(e){
        e.preventDefault();

        let id = $(this).attr('data-action-id'),
            $btn = $(this),
            $facade = $btn.siblings('.syncing-facade'),
            message = $btn.attr('data-message'),
            end_message = $btn.attr('data-end-message'),
            yes = $btn.attr('data-yes'),
            no = $btn.attr('data-no'),
            query_message = $btn.attr('data-query-message');

        bootbox.confirm({
            message: query_message,
            buttons: {
                confirm: {
                    label: yes,
                    className: 'btn-primary'
                },
                cancel: {
                    label: no,
                    className: 'btn-danger'
                }
            },
            callback: function (result) {
                if (result) {
                    $btn.addClass('d-none');
                    $facade.removeClass('d-none');
                    toastr.info(message);

                    $.ajax({
                        type : "GET",
                        url : '/settings/integrations/sync',
                        data : {
                            id
                        },
                        success : function(res){
                            if(res){
                                $btn.removeClass('d-none');
                                $facade.addClass('d-none');
                            }
                        }
                    })
                }
            }
        });
    });

    $('.schedule-integration-action').on('click', function(e){
        e.preventDefault();
        let id = $(this).attr('data-action-id'),
            $integration_modal = $('#integration-modal'),
            schedule = $(this).attr('data-schedule'),
            $week_holder = $('.integration-week-holder'),
            $month_holder = $('.integration-month-holder'),
            $time_holder = $('.integration-time-holder'),
            $save_btn = $('#save-integration-schedule'),
            $remove_btn = $('#remove-integration-schedule'),
            $cron_schedule = $('#cron-schedule'),
            $week_days = $('#cron-week-days'),
            $month_days = $('#cron-month-days'),
            $cron_time = $('#cron-time');


        $cron_schedule.val('');
        $week_days.selectpicker('val', []);
        $month_days.selectpicker('val', []);

        $week_holder.addClass('d-none');
        $month_holder.addClass('d-none');
        $time_holder.addClass('d-none');

        if(schedule.length){
            schedule = JSON.parse(schedule);
            let week_days = schedule.weeks.length ? JSON.parse(schedule.weeks) : [],
                month_days = schedule.days.length ? JSON.parse(schedule.days) : [];


            $cron_schedule.val(schedule.type);
            $week_days.selectpicker('val', week_days);
            $month_days.selectpicker('val', month_days);
            $cron_time.val(schedule.time);

            if(schedule.type === 'daily'){
                $week_holder.removeClass('d-none');
            }

            if(schedule.type === 'monthly'){
                $month_holder.removeClass('d-none');
            }

            $time_holder.removeClass('d-none');
            $remove_btn.removeClass('d-none');
        }else{
            $remove_btn.addClass('d-none');
        }

        $save_btn.attr('data-integration-id', id);
        $remove_btn.attr('data-integration-id', id);
        $integration_modal.modal('show');
    });

    $('#remove-integration-schedule').on('click', function(e){
        e.preventDefault();
        let id = $(this).attr('data-integration-id');

        $.ajax({
            type : 'DELETE',
            url : '/settings/integrations/schedule',
            data : {
                id
            },
            success : function(res){
                $(`.schedule-integration-action[data-action-id="${id}"]`).attr('data-schedule', '');
                $('#integration-modal').modal('hide');
                toastr.success('Schedule removed');
            }
        })
    })

    $('#cron-schedule').on('change', function(e){
        let value = $(this).val(),
            $week_holder = $('.integration-week-holder'),
            $month_holder = $('.integration-month-holder'),
            $time_holder = $('.integration-time-holder');

        $week_holder.addClass('d-none');
        $month_holder.addClass('d-none');
        $time_holder.addClass('d-none');

        if(value.length){
            if(value === 'daily'){
                $week_holder.removeClass('d-none');
            }

            if(value === 'monthly'){
                $month_holder.removeClass('d-none');
            }

            $time_holder.removeClass('d-none');
        }
    });

    $('#save-integration-schedule').on('click', function(e){
        e.preventDefault();

        let id = $(this).attr('data-integration-id'),
            type = $('#cron-schedule').val(),
            week_days = $('#cron-week-days').val(),
            month_days = $('#cron-month-days').val(),
            time = $('#cron-time').val();

        if(type === 'daily' && !week_days.length){
            alert('Please select weekdays');
            return;
        }

        if(type === 'monthly' && !month_days.length){
            alert('Please select month days');
            return;
        }

        if(!time.length){
            alert('Please select time');
            return;
        }

        $.ajax({
            type : 'POST',
            url : '/settings/integrations/schedule',
            data : {
                id, type, week_days, month_days, time
            },
            success : function(res){
                $(`.schedule-integration-action[data-action-id="${id}"]`).attr('data-schedule', JSON.stringify(res));
                $('#integration-modal').modal('hide');
                toastr.success('Schedule updated');
            }
        })
    });

    $('.toggle-action').on('click', function(e){
        let id = $(this).attr('data-action-id'),
            enabled = $(this).is(':checked') ? 1 : 0,
            $syncing_indicator = $(this).parents('tr').find('.sync-indicators');

        $.ajax({
            type : 'POST',
            url : '/settings/integrations/enabled',
            data : {
                id, enabled
            },
            success : function(res){
                if(enabled){
                    toastr.success('Integration action enabled');
                    $syncing_indicator.removeClass('d-none');
                }else{
                    toastr.success('Integration action disabled');
                    $syncing_indicator.addClass('d-none');
                }
            }
        })
    });

    // Settings > Integrations > Connections: each company switch is saved as soon as it is toggled
    $('#connection-settings').on('change', '.connection-setting', function(e){
        let $switch = $(this),
            enabled = $switch.is(':checked') ? 1 : 0;

        $.ajax({
            type : 'POST',
            url : $('#connection-settings').data('url'),
            data : {
                option : $switch.attr('name'),
                enabled
            },
            success : function(res){
                toastr.success(res.message);
            },
            error : function(){
                // Show the switch as it really is, the change was not saved
                $switch.prop('checked', !enabled);
                toastr.error('Could not save the change, please try again');
            }
        })
    });

    $('#trigger_automations').on('change', function(e){
        if($(this).is(':checked')){
            $('.trigger-automations-full-sync-holder').removeClass('d-none');
        }else{
            $('.trigger-automations-full-sync-holder').addClass('d-none');
            $('#trigger_automations_full_sync').prop('checked', false);
        }
    });

    // Full sync can run an automation for every record, so ask before allowing it
    $('#trigger_automations_full_sync').on('change', function(e){
        let $switch = $(this);

        if(!$switch.is(':checked')){
            return;
        }

        $switch.prop('checked', false);

        bootbox.confirm({
            message: $switch.attr('data-message'),
            buttons: {
                confirm: {
                    label: $switch.attr('data-yes'),
                    className: 'btn-primary'
                },
                cancel: {
                    label: $switch.attr('data-no'),
                    className: 'btn-danger'
                }
            },
            callback: function (result) {
                if (result) {
                    $switch.prop('checked', true);
                }
            }
        });
    });

    $('input[name="allow_custom_url"]').on('change', function(e){
        if($(this).is(':checked')){
            $('#custom_url').removeClass('d-none');
        }else{
            $('#custom_url').addClass('d-none');
        }
    });

    $('.integration-link').on('click', function(e){
        let integration = $(this).attr('data-integration');
        window.history.replaceState(null, null, `?active=${integration}`);
    });

    $('.add-outlook-account').on('click', function(e){
        e.preventDefault();
        let $accounts = $('.outlook-accounts > tbody');

        $.ajax({
            type : 'GET',
            url : '/settings/calendar/accounts',
            success: function(res){
                $accounts.append(res);
            }
        })
    });

    $('.save-outlook-account').on('click', function(e){
        e.preventDefault();

        let accounts = [];

        $('.outlook-account').each(function(index, $account){
            $account = $($account);
            let id = $account.attr('data-id'),
                email = $account.find('.outlook-email').val(),
                user_id = $account.find('.account-id').val();

            accounts.push({
                id, email, user_id
            });

            $.ajax({
                type : 'POST',
                url : '/settings/calendar/accounts',
                data : {
                    accounts
                },
                success: function(res){
                    if(res){
                        window.location.reload();
                    }
                }
            })
        });
    });

    $(document).on('click', '.remove-outlook-account', function(e){
        e.preventDefault();
        let id = $(this).parents('.outlook-account').attr('data-id');

        if(id.length){
            $.ajax({
                type : 'DELETE',
                url : '/settings/calendar/accounts',
                data : {
                    id
                },
                success: (res) => {
                    if(res){
                        $(this).parents('.outlook-account').remove();
                    }
                }
            })
        }else{
            $(this).parents('.outlook-account').remove();
        }
    })
});